import React from "react";
import type {PrintoutFieldAttrs} from "./printoutFieldOptions";

const FieldView = ({attrs}: {attrs: PrintoutFieldAttrs}) => (
    <div
        className="printout-field-block"
        data-printout-field-line-style={attrs.lineStyle}
        style={{
            "--printout-field-fill-color": attrs.fillColor ?? "transparent",
            "--printout-field-height": `${attrs.heightMm}mm`,
            "--printout-field-line-color": attrs.lineColor,
        } as React.CSSProperties}
    >
        <div className="printout-field-input"/>
        <div
            className="printout-field-label"
            style={{
                fontStyle: attrs.labelStyle.italic ? "italic" : "normal",
                fontWeight: attrs.labelStyle.bold ? 700 : 600,
                textAlign: attrs.align,
            }}
        >
            {attrs.label}
        </div>
    </div>
);

export default FieldView;
